module.exports = __webpack_public_path__ + "img/40047311.572589fc.png";